import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import { a11y } from '~js/components/a11y';
import { LoadPhotoswipe } from '~js/components/load-photoswipe';

export class VideoPlay {
  constructor(container) {
    this.container = container;
    this.videoPlay = this.container.querySelectorAll(s.selectors$y.videoPlay);
    this.a11y = a11y;

    this.init();
  }

  init() {
    if (this.videoPlay.length) {
      this.videoPlay.forEach((element) => {
        element.addEventListener('click', (e) => {
          if (
            element.hasAttribute(a.attributes$l.videoPlayValue) &&
            element.getAttribute(a.attributes$l.videoPlayValue).trim() !== ''
          ) {
            e.preventDefault();

            const items = [
              {
                html: element.getAttribute(a.attributes$l.videoPlayValue),
              },
            ];
            this.a11y.state.trigger = element;
            new LoadPhotoswipe(items);
          }
        });
      });
    }
  }
}